module.exports = __webpack_public_path__ + "static/media/football.e9dd319b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/football.png
// module id = 761
// module chunks = 0